import { render, staticRenderFns } from "./ModalSuccess.vue?vue&type=template&id=088cdb0a&"
import script from "./ModalSuccess.vue?vue&type=script&lang=ts&"
export * from "./ModalSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports